import { useCallback, useEffect, useState } from "react";

export const useShowMore = (mode: "line-clamp" | "truncate", forceState?: boolean) => {
  const [element, setElement] = useState<HTMLElement | null>(null);
  const [isShowMoreOpen, setIsShowMoreOpen] = useState(forceState);

  const ref = useCallback((node: HTMLElement | null) => {
    setElement(node);
  }, []);

  useEffect(() => {
    if (!element) {
      return;
    }

    const checkOverflow = () => {
      if (mode === "line-clamp") {
        setIsShowMoreOpen(element.scrollHeight > element.clientHeight);
      }
      if (mode === "truncate") {
        setIsShowMoreOpen(element.offsetWidth < element.scrollWidth);
      }
    };

    checkOverflow();

    const resizeObserver = new ResizeObserver(checkOverflow);

    resizeObserver.observe(element);

    return () => {
      resizeObserver.disconnect();
    };
  }, [element, mode]);

  return { ref, showMore: isShowMoreOpen };
};
